import { format } from "date-fns";

const dateTimeFormat = "dd/MM/yyyy hh:mmaaa";

const formatDateTime = (date: Date): string => {
  return format(date, dateTimeFormat);
};

export default formatDateTime;
